import { useI18n } from '@/hooks/web/useI18n'
import { Layout } from '@/utils/routerHelper'

const { t } = useI18n()

const dassetOverviewdRouter: AppRouteRecordRaw[] = [
  // 数据看板
  {
    path: '/asset-overview',
    component: Layout,
    name: 'AssetOverview',
    redirect: '/asset-overview/index',
    meta: {
      icon: 'carbon:data-view',
      title: t('router.dataOverView'),
      permission: ['ao']
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/AssetOverview/index.vue'),
        name: 'AssetOverview',
        meta: {
          title: t('router.dataOverView'),
          icon: 'carbon:data-view',
          permission: ['ao']
        }
      }
    ]
  }
]

export default dassetOverviewdRouter
